import {
  CREATE_COLLECTION_METHOD,
  EDIT_COLLECTION_METHOD,
  FETCH_COLLECTION_METHOD,
  DELETE_COLLECTION_METHOD,
  CLEAR_COLLECTION_METHOD,
  RELOAD_SOCKET
} from "../actions/types";
import { camelify } from "../utils/caseConvert";
import _ from "lodash";

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = {}, action) => {
  const collectionMethodCount = state?.count || 0;
  switch (action.type) {
    case FETCH_COLLECTION_METHOD:
      return {
        ...state,
        ..._.mapKeys(
          action.payload?.collectionMethods?.map((s) => camelify(s)),
          "id"
        ),
        count: action.payload?.count,
      };
    case CREATE_COLLECTION_METHOD:
      return {
        ...state,
        [action.payload?._id]: camelify(action.payload),
        count: collectionMethodCount + 1,
      };
    case EDIT_COLLECTION_METHOD:
      return { ...state, [action.payload?._id]: camelify(action.payload) };
    case DELETE_COLLECTION_METHOD:
      return {
        ..._.omit(state, action.payload),
        count: Math.max(collectionMethodCount - 1, 0),
      };
    case CLEAR_COLLECTION_METHOD:
      return {}
    case RELOAD_SOCKET:
      return {}
    default:
      return state;
  }
};
